import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const marketplaceHomeSearchedEventSchema = z.object({
  mode: z.enum(['keyword', 'semantic']).optional().describe('Search mode.'),
  filters: z
    .record(z.any())
    .describe('It contains filters used for searching.'),
});

export type MarketplaceHomeSearchedEvent = z.infer<
  typeof marketplaceHomeSearchedEventSchema
>;

export const marketplaceHomeSearchedTopic =
  createTopic<MarketplaceHomeSearchedEvent>(
    {
      namespace: 'marketplace',
      name: 'home-searched',
      description: 'User searched something from the marketplace home page.',
    },
    marketplaceHomeSearchedEventSchema,
    s => [{ action: ConfigActions.HASH, path: s.filters }],
  );
